export default __webpack_public_path__ + "static/media/planning.11efa8e4.png";